/**
 * @desc 查询年计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearInfoResponse>> {
  return defHttp.post({
    url: '/web/plan/year/queryPlanInfo',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearInfoResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/year/queryPlanInfo',
    data,
  });
}
